import { t } from '@lingui/macro';

import { Page, PageHeader, FilterContainer, PanelContainer } from '../../page-framework';
import { StatusFilter, TimeRangeFilter, SiteGroupFilter } from '../../filters';
import { SiteListPanel } from '../../panels';

export const pageId = 'sites';

export default function SitesPage() {
    return (
        <Page id={pageId}>
            <PageHeader title={t`Sites`}>
                <FilterContainer>
                    <SiteGroupFilter />
                    <TimeRangeFilter required />
                    <StatusFilter />
                </FilterContainer>
            </PageHeader>
            <PanelContainer>
                <SiteListPanel hideTitle flexHeight />
            </PanelContainer>
        </Page>
    );
}
